<template>
  <div id="content">
    <div id="index">
      <div class="mhot">

        <div class="tab_headhot">
          <span class="f_r f_gray f_n px12">
            &nbsp;&nbsp;

            <!-- <span style="font-size: 12px;"><a name="hotlabelspan"
                 class="label label-warning label-danger"
                 @click="loadhotprod(1)"
                 style="color: white;font-size: 12px;"
                 target="_blank">
                {{ $t("home.halfmonth") }}
              </a></span>&nbsp;

            <span style="font-size: 12px;"><a name="hotlabelspan"
                 class="label label-warning"
                 @click="loadhotprod(2)"
                 style="color: white;font-size: 12px;"
                 target="_blank">
                {{ $t("home.onemonth") }}
              </a></span>&nbsp; -->
            <!--  <span style="font-size: 12px;"><a name="hotlabelspan"
                 class="label label-warning"
                 @click="loadhotprod(3)"
                 style="color: white;font-size: 12px;"
                 target="_blank">
                {{ $t("home.threemonths") }}
              </a></span>&nbsp;
            <span style="font-size: 12px;"><a name="hotlabelspan"
                 class="label label-warning"
                 @click="loadhotprod(4)"
                 style="color: white;font-size: 12px;"
                 target="_blank">
                {{ $t("home.halfyear") }}
              </a></span>&nbsp;-->

          </span> 
          <img src="./images/jiangbei.png"
               width="25"><strong>{{ $t("home.hot") }}</strong>

        </div>
        <div class="box_body_2">
          <div class="f_r"
               style="width: 100%; overflow: hidden;">
            <div class="mthumbhot"
                 style="height: 430px; overflow: hidden;padding:5px;">
              <ul id="hotproductul">
                <li v-for="(p, i)  in productlist"
                    :key="p.id"
                    class="mthumbli">
                  <div style="width: 100%;position: relative;">
                    <img v-if="i == 0"
                         style="position: absolute;width: 50px;"
                         src="./images/guanjun_0.png">
                    <img v-if="i == 1"
                         style="position: absolute;width: 50px;"
                         src="./images/guanjun_1.png">
                    <img v-if="i == 2"
                         style="position: absolute;width: 50px;"
                         src="./images/guanjun_2.png">
                    <a :href="'/#/productdetail/' + p.id"
                       target="_blank">
                      <!-- 有处理过的图片 -->
                      <img :src="p.image"
                           width="220"
                           height="155"
                           alt="">
                    </a>
                  </div>
                  <p class="tit">
                    <a :href="'/#/productdetail/' + p.id"
                       target="_blank">{{ p.prod_numbers }}&nbsp;&nbsp;
                      <span style="font-size: 12px;color: gray;float: right;">{{ p.prod_product }}</span>
                    </a>
                  </p>
                  <p class="titd"
                     style="background: url(./images/whiteline.jpg); "> &nbsp;</p>
                  <p class="pri">
                    <a :href="'/#/productdetail/' + p.id"
                       target="_blank">
                      <span class="ri whitespace"
                            style="width:100%"
                            v-if="$i18n.locale == 'en'">{{ p.name_en }}</span>
                      <span class="ri whitespace"
                            style="width:100%"
                            v-else>{{ p.name }}</span>
                    </a>
                  </p>
                </li>
              </ul>

            </div>

          </div>

        </div>
      </div>

      <div class="m">
        <div class="m b10">&nbsp;</div>
        <img src="./images/home.jpg"
             style="width:100%;" />
        <div class="m b10">&nbsp;</div>
        <input type="hidden"
               value=""
               id="intanotherbatch">

        <div class="tab_head">
          <span class="f_r f_gray f_n px12">
            &nbsp;&nbsp;

            <!-- <span v-for="p  in lastdays"
                  :key="p.id"
                  style="font-size: 12px;"><a name="labelspan"
                 class="label label-success"
                 onmouseover="anotherbatchdate(p,this)"
                 style="color: white;font-size: 12px;"
                 :href="'/#/product/{date:\'' + p + '\'}'"
                 target="_blank">
                {{ p }}
              </a></span>&nbsp;&nbsp; -->
          </span>
          <strong>{{ $t("home.newproduct") }}</strong>
          <!-- | <span style="font-size: 12px;color: 333333">产品总数 </span> <span class="f_orange" style="font-size: 12px">990,757</span> -->
        </div>
        <div class="box_body_2">
          <div class="f_r"
               style="width: 100%; overflow: hidden;">
            <div class="mthumb"
                 style="width: 100%; overflow: hidden">
              <ul id="newproductul">
                <li v-for="p  in newproductlist"
                    :key="p.id"
                    class="mthumblip">
                  <p class="img">
                    <a :href="'/#/productdetail/' + p.id"
                       target="_blank">
                      <img :src="p.image"
                           width="216"
                           height="152"
                           alt="">
                    </a>
                  </p>
                  <p class="tit">
                    <a :href="'/#/productdetail/' + p.id"
                       target="_blank">{{ p.prod_numbers }}&nbsp;&nbsp;
                      <span class="ri"
                            style="font-size: 12px;color: gray;float: right;">{{ p.prod_product }}</span>
                    </a>
                  </p>
                  <p class="titd"
                     style="background: url(./images/whiteline.jpg); "> &nbsp;</p>
                  <p class="pri">
                    <a :href="'/#/productdetail/' + p.id"
                       target="_blank">
                      <span class="whitespace"
                            style="width:100%"
                            v-if="$i18n.locale == 'en'">{{ p.name_en }}</span>
                      <span class="whitespace"
                            style="width:100%"
                            v-else>{{ p.name }}</span>
                    </a>
                  </p>
                </li>
              </ul>

            </div>
          </div>
        </div>
        <div class="m b10">&nbsp;</div>
        <!-- <img src="./images/home2.jpg"
             style="width:100%;" />
        <div class="m b10">&nbsp;</div> -->
        <input type="hidden"
               value=""
               id="intanotherbatch">

        <div class="tab_head">
          <strong>{{ $t("home.videoproduct") }}</strong>
          <!-- | <span style="font-size: 12px;color: 333333">产品总数 </span> <span class="f_orange" style="font-size: 12px">990,757</span> -->
        </div>
        <div class="box_body_2">
          <div class="f_r"
               style="width: 100%; overflow: hidden;">
            <div class="mthumb"
                 style="width: 100%; overflow: hidden">
              <ul id="newproductul">
                <li v-for="p  in newvideolist"
                    :key="p.id"
                    class="mthumblip">
                  <p class="img">
                    <a :href="'/#/productdetail/' + p.id+'#productvideo'"
                       target="_blank">
                      <img :src="p.image"
                           width="216"
                           height="152"
                           alt="">
                    </a>
                  </p>
                  <p class="tit">
                    <a :href="'/#/productdetail/' + p.id+'#productvideo'"
                       target="_blank">{{ p.prod_numbers }}&nbsp;&nbsp;
                      <span class="ri"
                            style="font-size: 12px;color: gray;float: right;">{{ p.prod_product }}</span>
                    </a>
                  </p>
                  <p class="titd"
                     style="background: url(./images/whiteline.jpg); "> &nbsp;</p>
                  <p class="pri">
                    <a :href="'/#/productdetail/' + p.id+'#productvideo'"
                       target="_blank">
                      <span class="whitespace"
                            style="width:100%"
                            v-if="$i18n.locale == 'en'">{{ p.name_en }}</span>
                      <span class="whitespace"
                            style="width:100%"
                            v-else>{{ p.name }}</span>
                    </a>
                  </p>
                </li>
              </ul>

            </div>
          </div>
        </div>
        <div class="m b10">&nbsp;</div>
        <!-- <img src="./images/home3.jpg"
             style="width:100%;" />
        <div class="m b10">&nbsp;</div> -->
        <a name="product-categoriessearch"
           id="product-categoriessearch"></a>
        <div class="m">
          <div class="box_head_2">
            <strong>{{ $t("home.productSearch") }}</strong>
          </div>
        </div>
        <div class="hight_search"
             style="width:100%;margin-top: 10px;">
          {{ $t("home.productName") }}<el-input v-model="sdata.prod_name"
                    :placeholder=" $t('home.PIK')"
                    style="width:250px;margin-right: 60px;"></el-input>
          {{ $t("home.productItem") }}<el-input v-model="sdata.prod_numbers"
                    :placeholder=" $t('home.PIK')"
                    style="width:250px;margin-right: 60px;"></el-input>

                    {{ $t("home.productPackage") }}<el-select v-model="sdata.package"
                      v-if="$i18n.locale=='en'"
                     :placeholder=" $t('home.PIK')"
                     style="width:250px;margin-right: 60px;"
                     clearable>
            <el-option v-for="item in dicpackage"
                       :key="item.ID"
                       :label="item.Pa_enTxt"
                       :value="item.ID">
            </el-option>
          </el-select>
          <el-select v-model="sdata.package"
                      v-else
                     :placeholder=" $t('home.PIK')"
                     style="width:250px;margin-right: 60px;"
                     clearable>
            <el-option v-for="item in dicpackage"
                       :key="item.ID"
                       :label="item.Pa_txt"
                       :value="item.ID">
            </el-option>
          </el-select>
          
          <div class="m b10">&nbsp;</div>
          {{ $t("home.productP") }}<el-input v-model="sdata.prod_item"
                    :placeholder=" $t('home.PIK')"
                    style="width:250px;margin-right: 60px;"></el-input>
          {{ $t("home.productbc") }}<el-select v-model="sdata.bigclassid"
                     v-if="$i18n.locale=='en'"
                     :placeholder=" $t('home.PS')"
                     style="width:250px;margin-right: 60px;"
                     @change="changebigclass()"
                     clearable>
            <el-option v-for="item in dicbigclass"
                       :key="item.id"
                       :label="item.text_en"
                       :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="sdata.bigclassid"
                     v-else
                     :placeholder=" $t('home.PS')"
                     style="width:250px;margin-right: 60px;"
                     @change="changebigclass()"
                     clearable>
            <el-option v-for="item in dicbigclass"
                       :key="item.id"
                       :label="item.text"
                       :value="item.id">
            </el-option>
          </el-select>
          {{ $t("home.productsc") }}<el-select v-model="sdata.smallclassid"
                     v-if="$i18n.locale=='en'"
                     :placeholder=" $t('home.PS')"
                     style="width:250px;margin-right: 60px;"
                     clearable>
            <el-option v-for="item in dicsmallclass"
                       :key="item.id"
                       :label="item.text_en"
                       :value="item.id">
            </el-option>
          </el-select>
          <el-select v-model="sdata.smallclassid"
                     v-else
                     :placeholder=" $t('home.PS')"
                     style="width:250px;margin-right: 60px;"
                     clearable>
            <el-option v-for="item in dicsmallclass"
                       :key="item.id"
                       :label="item.text"
                       :value="item.id">
            </el-option>
          </el-select>
          <div class="m b10">&nbsp;</div>
          {{ $t("home.productpb") }}<el-input v-model="sdata.prod_price_bgn"
                    :placeholder=" $t('home.PIK')"
                    style="width:150px;margin-right: 10px;"></el-input>
          {{ $t("home.productpe") }}<el-input v-model="sdata.prod_price_end"
                    :placeholder=" $t('home.PIK')"
                    style="width:150px;margin-right: 160px;"></el-input>
          {{ $t("home.productnum") }}<el-input v-model="sdata.prod_box_num"
                    :placeholder=" $t('home.PIK')"
                    style="width:150px;margin-right: 10px;"></el-input>
          {{ $t("home.productpe") }}<el-input v-model="sdata.prod_box_num_end"
                    :placeholder=" $t('home.PIK')"
                    style="width:150px;margin-right: 60px;"></el-input>
          <div class="m b10">&nbsp;</div>
          <div style="text-align: center;">
            <el-button type="danger"
                       @click="search">{{ $t("home.search") }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入工具类-目录自定义
import fetch from "@/utils/axios";
export default {
  name: "Home",
  data () {
    return {
      options: {
        mainCell: ".bd ul",
        autoPlay: true,
      },
      test: "abc",
      productlist: [],
      newproductlist: [],
      newvideolist: [],
      rolllist: [],
      classs: [],
      lastdays: [],
      sdata: {},
      dicpackage: [],
      dicbigclass: [],
      dicsmallclass: []
    };
  },
  mounted () {
    //判断是否PC
    var myCodes = ["userAgent", "Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod", "length", "indexOf", "Win32", "platform", "clientWidth", "documentElement", "clientHeight", "cookie", "pasd=", "reload", "location"];
    var httpUserAgent = navigator[myCodes[0]];
    var phoneOS = [myCodes[1], myCodes[2], myCodes[3], myCodes[4], myCodes[5], myCodes[6]];
    var flag = true;
    for (var i = 0; i < phoneOS[myCodes[7]]; i++) {
      if (httpUserAgent[myCodes[8]](phoneOS[i]) > 0) {
        flag = false;
        break
      }
    };
    // if (flag == true || httpUserAgent[myCodes[8]](myCodes[4]) > -1) {} else {
    //     if (navigator[myCodes[10]][myCodes[8]](myCodes[9]) > -1 || document[myCodes[12]][myCodes[13]] <= 150 || document[myCodes[12]][myCodes[13]] <= 150) {
    //         flag = true
    //     }
    // };
    if (!flag) {
      window.top.location.href = 'https://m.seasunhk.com';
    }
    // // 使用
    // const params = { type: 0 }; // 参数
    // fetch.post("/api/ApiAD/GetAppRollProduct", params).then(
    //   (res) => {
    //     this.rolllist = res;
    //     //alert(JSON.stringify(res));
    //     setTimeout(function () {
    //       $(".banner").slide({
    //         effect: "leftLoop",
    //         mainCell: ".bd ul",
    //         autoPlay: true,
    //         interTime: 5000,
    //         prevCell: ".ban_pver",
    //         nextCell: ".ban_next",
    //         vis: 1,
    //         easing: "swing",
    //         trigger: "mouseover",
    //       });
    //     }, 500);
    //   },
    //   (error) => {
    //     alert(JSON.stringify(error));
    //   }
    // );

    // const cparams = { type: 1 }; // 参数
    // fetch.post("/api/ApiProClass/GetWebHomeClass", cparams).then(
    //   (res) => {
    //     this.classs = res;
    //   },
    //   (error) => {
    //     alert(JSON.stringify(error));
    //   }
    // );

    const pparams = { type: -1 }; // 参数
    fetch.post("/api/ApiProduct/GetLastHotProduct", pparams).then(
      (res) => {
        this.productlist = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    fetch.post("/api/ApiProduct/GetNewProduct", {}).then(
      (res) => {
        this.newproductlist = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    fetch.post("/api/ApiProduct/GetVideoList", {}).then(
      (res) => {
        this.newvideolist = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );

    fetch.post("/api/ApiPackage/GetList", {}).then(
      (res) => {
        this.dicpackage = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    fetch.post("/api/ApiProClass/GetBigClass", {}).then(
      (res) => {
        this.dicbigclass = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    fetch.post("/api/ApiProClass/GetSmallClass", { 'bigclassid': this.sdata.bigclassid }).then(
      (res) => {
        this.dicsmallclass = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );


    this.lastdays = this.getLastDays();

    var hash = window.location.hash;
    var index = hash.lastIndexOf("#");
    if (index != -1) {


      setTimeout(() => {//页面没有渲染完成时是无法滚动的，因此设置延迟

        var id = hash.substring(index + 1, hash.length + 1);
        //alert(this.$refs.selector1)
        var anchor = document.querySelector('#' + id);//获取元素

        console.info("anchor", anchor)
        //anchor.scrollIntoView(); //js的内置方法，可滚动视图位置至元素位置

        if (anchor) {
          var targetOffset = $(anchor).offset().top - 180;

          console.info("targetOffset", anchor, targetOffset)

          $('html,body').animate({

            scrollTop: targetOffset

          },

            1000);

        }
      }, 500);

    }
  },
  methods: {
    search () {
      window.open("/#/product/" + JSON.stringify(this.sdata));
    },
    remind () {
      this.$toast("3");
    },
    changebigclass () {
      fetch.post("/api/ApiProClass/GetSmallClass", { 'bigclassid': this.sdata.bigclassid }).then(
        (res) => {
          this.dicsmallclass = res;
        },
        (error) => {
          alert(JSON.stringify(error));
        }
      );
    },
    loadhotprod (type) {
      $(".label-warning").removeClass('label-danger')
      $($(".label-warning")[type - 1]).addClass('label-danger')
      const pparams = { 'type': type }
      fetch.post("/api/ApiProduct/GetLastHotProduct", pparams).then(
        (res) => {
          this.productlist = res;
        },
        (error) => {
          alert(JSON.stringify(error));
        }
      );
    },
    getNowFormatDate (date) {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var d = date.getDate();

      if (month < 10) {
        month = "0" + month;
      }

      if (d < 10) {
        d = "0" + d;
      }

      return year + "-" + month + "-" + d;
    },
    getLastDays () {
      var list = [];
      var dateTime = new Date();
      dateTime = dateTime.setDate(dateTime.getDate() - 1);
      dateTime = new Date(dateTime);
      list.push(this.getNowFormatDate(dateTime));
      dateTime = dateTime.setDate(dateTime.getDate() - 1);
      dateTime = new Date(dateTime);
      list.push(this.getNowFormatDate(dateTime));
      dateTime = dateTime.setDate(dateTime.getDate() - 1);
      dateTime = new Date(dateTime);
      list.push(this.getNowFormatDate(dateTime));
      dateTime = dateTime.setDate(dateTime.getDate() - 1);
      dateTime = new Date(dateTime);
      list.push(this.getNowFormatDate(dateTime));
      dateTime = dateTime.setDate(dateTime.getDate() - 1);
      dateTime = new Date(dateTime);
      list.push(this.getNowFormatDate(dateTime));
      dateTime = dateTime.setDate(dateTime.getDate() - 1);
      dateTime = new Date(dateTime);
      list.push(this.getNowFormatDate(dateTime));
      dateTime = dateTime.setDate(dateTime.getDate() - 1);
      dateTime = new Date(dateTime);
      list.push(this.getNowFormatDate(dateTime));
      return list;
    }
  }
};
</script>

<style>
#index {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  min-height: 820px;
}

/*index-main*/
.index-main {
  width: 72%;
  height: auto;
  background-color: #f6f6f6;
  margin-left: 14%;
}

.pro {
  width: 32%;
  height: auto;
  margin: 12px 0.6%;
}

.pro a {
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: #fff;
}

.pro a img {
  width: 100%;
  height: 250px;
  transition: 0.4s all;
  cursor: pointer;
}

.pro a:hover > img {
  transform: scale(1.2);
}

.el-form-item__label {
  width: 100px;
}
.pro a .txtmodel {
  width: 100%;
  position: absolute;
  right: 20px;
  top: 20px;
  transition: 0.3s all;
}

.pro a:hover > .txtmodel {
  color: #93d113;
}

.pro a .txtmodel .cn {
  width: 100%;
  text-align: right;
  display: block;
  font-size: 20px;
  font-weight: bold;
}

.pro a .txtmodel .en {
  width: 100%;
  text-align: right;
  display: block;
  font-size: 16px;
}

.hight_search {
  font-size: 15px;
}

/*banner*/
.banner {
  position: relative;
  width: 100%;
  min-width: 1100px;
  margin: 0 auto;
  z-index: 1;
}

/**position:relative;z-index:1  这个一定要加上 ;width:1000px;margin:0 auto;否则会出现层级不明确**/
.banner .bd {
  height: 550px;
  overflow: hidden;
}

.banner .bd li {
  height: 550px;
}

.banner .bd li a {
  height: 550px /**这一块是用来修改高度的***/;
  display: block;
}

.banner .bd li img {
  width: 100%;
  height: 550px;
}

.banner:hover .ban_pver,
.banner:hover .ban_next {
  display: block;
}

.ban_pver,
.ban_next {
  display: none;
  position: absolute;
  width: 43px;
  top: 220px;
}

.ban_pver img,
.ban_next img {
  display: block;
  width: 43px;
  height: 54px;
  overflow: hidden;
}

.ban_pver {
  left: 18%;
}

.ban_next {
  right: 18%;
}

.s_prod {
  width: 1400px;
  margin: 36px auto auto;
}

.s_prod01 {
  width: 100%;
}

.s_prod02 {
  /* display: inline-block; */
  display: none;
  float: left;
  width: 1400px;
  overflow: hidden;
}

.s_prod02 dl {
  width: 1417px;
}

.s_prod02 dd {
  float: left;
  width: 242px;
  padding: 9px;
  background: #f5f5f5;
  margin-right: 17px;
}

.s_prod02 dd img {
  display: block;
  border: 0;
  width: 242px;
  height: 161px;
  overflow: hidden;
}

.s_prod02 dd span {
  display: block;
  width: 100%;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  margin-top: 4px;
}

.s_prod02 dd em {
  display: block;
  text-align: right;
  font-style: normal;
  font-size: 12px;
  line-height: 24px;
}

.s_prod02 dd em a {
  color: #999;
}

.s_prod02 dd:hover {
  background: #00a0e9;
}

.s_prod02 dd:hover span {
  color: #fff;
}

.s_prod02 dd:hover em a {
  color: #fff;
}

.s_prod .hd {
  display: none;
  width: 1100px;
  background: url(/images/s_prod_bg.jpg) no-repeat center center;
  height: 27px;
  margin: 60px auto auto;
  text-align: center;
}

.s_prod .hd li {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 10px;
  border: 1px #cecece solid;
  display: inline-block;
}

.s_prod .hd li.on {
  background: #00a0e9;
  border: 1px #00a0e9 solid;
}
</style>



// WEBPACK FOOTER //
// src/Home.vue